import { createContext, useContext, useEffect, useState } from "react";
import { TRANSLATIONS, LANGS } from "./translations";

const LanguageContext = createContext({
  lang: "fr",
  setLang: () => {},
  t: TRANSLATIONS.fr,
  langs: LANGS,
});

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "fr";
    const stored = window.localStorage.getItem("lacaravelle_lang");
    if (stored && TRANSLATIONS[stored]) return stored;
    return "fr";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem("lacaravelle_lang", lang);
      document.documentElement.setAttribute("lang", lang);
    }
  }, [lang]);

  const value = {
    lang,
    setLang,
    t: TRANSLATIONS[lang] || TRANSLATIONS.fr,
    langs: LANGS,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
